export default __webpack_public_path__ + "static/2024 StM Annual School Report-7bd64a2bdcfb8af259d888b277f144d7.pdf";